function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import React from 'react';
import { memoize as memoizeFn } from '@shopify/function-enhancers';
import { pseudotranslate as pseudotranslateString } from '@shopify/i18n';
import { MissingTranslationError, MissingReplacementError } from "../errors.mjs";
var REPLACE_REGEX = /{([^}]*)}/g;
var MISSING_TRANSLATION = Symbol('Missing translation');
var PLURALIZATION_KEY_NAME = 'count';
var SEPARATOR = '.';
var numberFormats = new Map();
export function memoizedNumberFormatter(locales, options) {
  var key = numberFormatCacheKey(locales, options);
  if (numberFormats.has(key)) {
    return numberFormats.get(key);
  }
  var i = new Intl.NumberFormat(locales, options);
  numberFormats.set(key, i);
  return i;
}
export var PSEUDOTRANSLATE_OPTIONS = {
  startDelimiter: '{',
  endDelimiter: '}',
  prepend: '[!!',
  append: '!!]'
};
export function numberFormatCacheKey(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var localeKey = Array.isArray(locales) ? locales.sort().join('-') : locales;
  return "".concat(localeKey, "-").concat(JSON.stringify(options));
}
function pluralRules(locale) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Intl.PluralRules(locale, options);
}
export var memoizedPluralRules = memoizeFn(pluralRules, function (locale) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return "".concat(locale).concat(JSON.stringify(options));
});
export function getTranslationTree(id, translations, locale, replacements) {
  var normalizedTranslations = Array.isArray(translations) ? translations : [translations];
  var result;
  var _iterator = _createForOfIteratorHelper(normalizedTranslations),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var translationDictionary = _step.value;
      result = translationDictionary;
      var _iterator2 = _createForOfIteratorHelper(id.split(SEPARATOR)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var part = _step2.value;
          result = result[part];
          if (!result) break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (result) {
        if (replacements) {
          return typeof result === 'string' ? updateStringWithReplacements(result, replacements) : updateTreeWithReplacements(result, locale, replacements);
        }
        return result;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  throw new MissingTranslationError(id, locale);
}
export function translate(id, options, translations, locale) {
  var scope = options.scope,
    replacements = options.replacements,
    pseudotranslate = options.pseudotranslate;
  var normalizedTranslations = Array.isArray(translations) ? translations : [translations];
  var normalizedId = normalizeIdentifier(id, scope);
  var _iterator3 = _createForOfIteratorHelper(normalizedTranslations),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var translationDictionary = _step3.value;
      var result = translateWithDictionary(normalizedId, translationDictionary, locale, replacements, {
        pseudotranslate: pseudotranslate
      });
      if (result !== MISSING_TRANSLATION) {
        return result;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  throw new MissingTranslationError(normalizedId, locale);
}
function translateWithDictionary(id, translations, locale, replacements) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
    _ref$pseudotranslate = _ref.pseudotranslate,
    pseudotranslate = _ref$pseudotranslate === void 0 ? false : _ref$pseudotranslate;
  var result = translations;
  var _iterator4 = _createForOfIteratorHelper(id.split(SEPARATOR)),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var part = _step4.value;
      if (result == null || _typeof(result) !== 'object') {
        return MISSING_TRANSLATION;
      }
      result = result[part];
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var additionalReplacements = {};
  if (_typeof(result) === 'object' && replacements != null && Object.prototype.hasOwnProperty.call(replacements, PLURALIZATION_KEY_NAME)) {
    var count = replacements[PLURALIZATION_KEY_NAME];
    if (typeof count === 'number') {
      var group = memoizedPluralRules(locale).select(count);
      result = result[group];
      additionalReplacements[PLURALIZATION_KEY_NAME] = memoizedNumberFormatter(locale).format(count);
    }
  }
  var processedString = typeof result === 'string' && pseudotranslate ? pseudotranslateString(result, _objectSpread(_objectSpread({}, PSEUDOTRANSLATE_OPTIONS), {}, {
    toLocale: typeof pseudotranslate === 'boolean' ? undefined : pseudotranslate
  })) : result;
  if (typeof processedString === 'string') {
    return updateStringWithReplacements(processedString, _objectSpread(_objectSpread({}, replacements), additionalReplacements));
  } else {
    return MISSING_TRANSLATION;
  }
}
function updateStringWithReplacements(str) {
  var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var replaceFinder = /([^{]*)({([^}]*)})?/g;
  var allReplacementsArePrimitives = Object.keys(replacements).every(function (key) {
    return _typeof(replacements[key]) !== 'object';
  });
  if (allReplacementsArePrimitives) {
    return str.replace(REPLACE_REGEX, function (match) {
      var replacement = match.substring(1, match.length - 1);
      if (!Object.prototype.hasOwnProperty.call(replacements, replacement)) {
        throw new MissingReplacementError(replacement, replacements);
      }
      return replacements[replacement];
    });
  } else {
    var pieces = [];
    var match = replaceFinder.exec(str);
    var matchIndex = 0;
    while (match) {
      var regularText = match[1];
      var replacement = match[3];
      if (match.index >= str.length) {
        break;
      }
      if (regularText) {
        pieces.push(regularText);
      }
      if (replacement) {
        if (!Object.prototype.hasOwnProperty.call(replacements, replacement)) {
          throw new MissingReplacementError(replacement, replacements);
        }
        matchIndex += 1;
        var finalReplacement = /*#__PURE__*/ /*#__PURE__*/React.isValidElement(replacements[replacement]) ? /*#__PURE__*/React.cloneElement(replacements[replacement], {
          key: matchIndex
        }) : replacements[replacement];
        pieces.push(finalReplacement);
      }
      match = replaceFinder.exec(str);
    }
    replaceFinder.lastIndex = 0;
    return pieces;
  }
}
function normalizeIdentifier(id, scope) {
  if (scope == null) {
    return id;
  }
  return "".concat(typeof scope === 'string' ? scope : scope.join(SEPARATOR)).concat(SEPARATOR).concat(id);
}
function updateTreeWithReplacements(translationTree, locale, replacements) {
  if (Object.prototype.hasOwnProperty.call(replacements, PLURALIZATION_KEY_NAME)) {
    var count = replacements[PLURALIZATION_KEY_NAME];
    if (typeof count === 'number') {
      var group = memoizedPluralRules(locale).select(count);
      if (typeof translationTree[group] === 'string') {
        return updateStringWithReplacements(translationTree[group], _objectSpread(_objectSpread({}, replacements), {}, {
          PLURALIZATION_KEY_NAME: memoizedNumberFormatter(locale).format(count)
        }));
      }
    }
  }
  return Object.keys(translationTree).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, typeof translationTree[key] === 'string' ? updateStringWithReplacements(translationTree[key], replacements) : updateTreeWithReplacements(translationTree[key], locale, replacements)));
  }, {});
}